interface Props {
  title: string
  description: string
  status: string
}

export default function AgentPageHeader({ title, description, status }: Props) {
  const isLive = status === 'Live'

  return (
    <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6 mt-8 mb-10">
      <div className="flex items-start gap-5">
        <div className="w-14 h-14 rounded-xl bg-brand/10 border border-brand/20 flex items-center justify-center shrink-0">
          <svg className="w-7 h-7 text-brand" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
          </svg>
        </div>
        <div>
          <h1 className="text-3xl font-bold text-gray-900 tracking-tight">{title}</h1>
          <p className="mt-1.5 text-gray-500 text-sm leading-relaxed max-w-lg">{description}</p>
          <div className="flex flex-wrap items-center gap-2 mt-3">
            <span className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium bg-sky-500/10 text-sky-600 ring-1 ring-sky-500/20">
              Image / PDF support
            </span>
            <span className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium bg-emerald-500/10 text-emerald-600 ring-1 ring-emerald-500/20">
              Structured JSON
            </span>
            <span className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium bg-amber-500/10 text-amber-600 ring-1 ring-amber-500/20">
              Human review
            </span>
          </div>
        </div>
      </div>

      <div className="lg:w-56 shrink-0 rounded-xl border border-gray-200 bg-gray-50 p-4">
        <p className="text-gray-500 text-xs font-medium uppercase tracking-wider mb-2">Agent status</p>
        <div className="flex items-center gap-2 mb-2">
          <span className={`w-2 h-2 rounded-full shrink-0 ${isLive ? 'bg-emerald-500' : 'bg-amber-400'}`} />
          <span className={`text-sm font-medium ${isLive ? 'text-emerald-600' : 'text-amber-600'}`}>{status}</span>
        </div>
        <p className="text-gray-400 text-xs leading-relaxed">
          {isLive ? 'This agent is ready to use.' : 'This agent is in development and will be available soon.'}
        </p>
      </div>
    </div>
  )
}
